import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Logo({ height = 32, className, style }) {
  const navigate = useNavigate();
  return (
    <img
      src={process.env.PUBLIC_URL + '/vitex-logo.png'}
      alt="ViTex"
      onClick={() => navigate('/')}
      draggable={false}
      className={className}
      style={{ height, width: 'auto', display: 'block', cursor: 'pointer', ...style }}
    />
  );
}
